import * as React from 'react';

import { View } from './view';
import { IDummyProps } from './types';

export type DragAndDropProps = IDummyProps;

export const DragAndDrop = (props: IDummyProps) => {
    return <View {...props} />;
};
